/** 当前需要用到的config */
export var config = {
  env: '',
  source: 501,
  domain: {
    msg: '',
    media: ''
  }
}; // 更新API配置

var setConfig = function setConfig(domain) {
  if (domain) {
    for (var key in config.domain) {
      if (domain[key]) {
        config.domain[key] = domain[key];
      }
    }
  }
};
/** 修改上面config对象 指定环境的域名 */


export function setDomainConfig(env, domain) {
  config.env = env;
  setConfig(domain);
}

if (window.feConfig) {
  setDomainConfig(window.feConfig.apiEnv, window.feConfig.common);
}

export default config;